export { LanternAnalyticsModule } from "./lantern-analytics.module";
